import { FundType, OperationTypeQuota, SettlementType, Ticket } from "./Entity";

export class FundQuota extends Ticket {
  // Dados Carteira

  portfolioDocument: string = null;
  portfolioBank: string = null;
  portfolioBranch: string = null;
  portfolioAccount: string = null;
  portfolioName: string = null;
  isInternalFund = false;
  portfolioCode: string = null;
  portfolioCetipAccount: string = null;
  portfolioFundId: number = null;
  portfolioFundAccountId: number = null;

  // Dados da Operação

  operationTypeId: OperationTypeQuota = null;
  fullRedeem: boolean = null;
  settlementTypeId: SettlementType = null;
  isSecondaryMarket: boolean = null;
  isIssueUnitPrice = false;
  operationValue: number = null;
  amount: number = null;
  quotaValue: number = null;
  isManualSettlementDate: boolean = null;
  settlementDate: Date = null;
  quotationDate: Date = null;
  subscriptionDate: Date = null;
  hasSameOwnership: boolean = null;
  isCetipVoice: boolean = null;
  cetipVoiceId: string = null;

  // TODO: Aguardando definição Liquidação Clearing
  // unitPrice: number = null;

  // - Dados do Fundo Investido

  fundName: string = null;
  fundDocument: string = null;
  isFIDC = false;
  fundClass: string = null;
  fundSeries: string = null;
  fundSeriesQuantity: number = null;
  isNewFund = false;
  issuerName: string = null;
  scheme: string = null;
  fundType: FundType = null;
  mnemonicCode: string = null;
  fundAdministrator: string = null;
  administratorAnnotation: string = null;

  fundBank: string = null;
  fundAccount: string = null;
  fundBranch: string = null;
  allowEmptyAccount: boolean = false;

  // TODO: Aguardando definição Liquidação Clearing
  // accountCetipCounterpart: number = null;

  // - Dados da Contraparte

  counterpartName: string = null;
  counterpartDocument: string = null;
  counterpartCetipAccount: string = null;
  command = "0";
  isNewCounterpart = true;

  annotations: string = null;

  tempTicketId: any = null;

  transferStatusDescription: string = null;

  constructor() {
    super();
  }
}
